import React from 'react';
import LegalPageLayout from '../components/LegalPageLayout';

const AdatvedelemPage = () => (
  <LegalPageLayout
    testId="adatvedelem-page"
    title="Adatkezelési Tájékoztató"
    metaDescription="GDPR-megfelelő adatkezelési tájékoztató — kezelt adatok köre, célja, jogalapja, adatfeldolgozók és érintetti jogok."
    canonicalPath="/adatvedelem"
    updatedAt="2026-07-14"
  >
    <section>
      <h2 className="text-xl font-bold text-gray-900 mb-3" style={{ fontFamily: 'Montserrat, sans-serif' }}>
        1. Az Adatkezelő adatai
      </h2>
      <ul className="list-disc pl-6 space-y-1.5">
        <li><strong>Név/Cégnév:</strong> Orosz Gábor</li>
        <li><strong>Székhely:</strong> Magyarország, 3530 Miskolc, Dankó Pista utca 27. 5/1.</li>
        <li><strong>E-mail cím:</strong>{' '}
          <a href="mailto:info@oroszcoaching.hu" className="text-yellow-700 hover:text-yellow-600 font-semibold">info@oroszcoaching.hu</a>
        </li>
        <li><strong>Telefonszám:</strong>{' '}
          <a href="tel:+36702378299" className="text-gray-900">+36 70 237 8299</a>
        </li>
      </ul>
    </section>

    <section>
      <h2 className="text-xl font-bold text-gray-900 mb-3" style={{ fontFamily: 'Montserrat, sans-serif' }}>
        2. A kezelt adatok köre, célja és jogalapja
      </h2>
      <p>
        A Szolgáltató az alábbi célokból kezel személyes adatokat a Felhasználó önkéntes <strong>hozzájárulása</strong> alapján
        (jogalap: GDPR 6. cikk (1) bekezdés a) pontja):
      </p>
      <ul className="list-disc pl-6 space-y-2 mt-3">
        <li>
          <strong>A fitness- és testzsír-kalkulátorok használata:</strong> A megadott testi adatok (nem, kor, súly, magasság,
          nyak-, derék-, csípő- és vállkerület) és az e-mail cím kezelésének célja az egyedi kalória- és esztétikai
          kiértékelés elkészítése, valamint az adatok elmentése a Felhasználó számára.
        </li>
        <li>
          <strong>Időpontfoglalás és kapcsolattartás:</strong> A név és az e-mail cím kezelésének célja a konzultációs
          időpontok rögzítése, kezelése és az e-mailes visszaigazolás/értesítések kiküldése.
        </li>
        <li>
          <strong>Hírlevél és edukációs kampányok:</strong> A név és e-mail cím kezelésének célja a heti rendszerességű
          szakmai és edzéselméleti hírlevelek (Drip kampány) eljuttatása a Felhasználóhoz.
        </li>
        <li>
          <strong>Ügyfélfiók (Kliens Portál) létrehozása és üzemeltetése:</strong> A regisztrációnál megadott név, e-mail cím,
          opcionális telefonszám, jelszó (bcrypt algoritmussal hash-elve tárolt, visszafejthetetlen formában), valamint a Google
          bejelentkezés esetén a Google fiókból átvett név és e-mail cím kezelésének célja a Felhasználó azonosítása,
          a bérletek (megvásárolt csomagok) és személyes edzés-foglalások nyilvántartása. Jogalap: GDPR 6. cikk (1) b) — a
          Felhasználóval kötött szerződés teljesítése (a szolgáltatás nyújtása).
        </li>
        <li>
          <strong>Bérletek és edzés-foglalások kezelése:</strong> A megvásárolt bérlet adatai (csomag típusa, alkalmak száma,
          lejárati dátum, felhasznált / hátralévő alkalmak, fagyasztás időszaka), valamint a lefoglalt edzés-időpontok
          (dátum, időpont, megjelenési státusz) kezelése. Cél: a szolgáltatás pontos nyújtása és a bérletek elszámolása.
          Jogalap: GDPR 6. cikk (1) b) — szerződés teljesítése; a számviteli bizonylathoz kapcsolódó adatok esetén GDPR 6. cikk
          (1) c) — jogi kötelezettség teljesítése (a Sztv. 8 éves megőrzési kötelezettsége).
        </li>
        <li>
          <strong>Automatizált retenciós értesítések és hűségkupon kiadása:</strong> Ha a Felhasználó aktív bérlete
          <strong> 7 napon belül lejár</strong>, vagy <strong>2 alkalomnál kevesebb van hátra</strong> belőle, a rendszer
          automatikusan emlékeztető e-mailt küld, illetve — a lejárathoz közelítő bérletek esetén — egy egyszer felhasználható,
          személyre szóló 10%-os kupont generál. A kezelt adatok köre: e-mail cím, név, bérlet státusza. Jogalap: GDPR 6. cikk
          (1) f) — az Adatkezelő <em>jogos érdeke</em> a szolgáltatás folyamatosságának és a vásárlói elköteleződésnek a
          fenntartása. A Felhasználó ezekről az üzenetekről bármikor leiratkozhat (lásd 8. pont).
        </li>
        <li>
          <strong>Edzésterv és haladáskövetés (egészségügyi jellegű adatok):</strong> A Kliens Portálon elérhető
          edzésterv-szolgáltatás keretében kezelt adatok: a Felhasználó részére készített személyre szabott edzésterv
          (gyakorlatok, sorozat- és ismétlésszámok, intenzitás) és annak korábbi változatai; az edzésnapló bejegyzései
          (gyakorlat, használt súly, ismétlés- és sorozatszám); valamint a testméret-adatok (testsúly, nyak-, derék- és
          csípőkörméret) és az ezekből képzett fejlődési kimutatások. Ezek az adatok <strong>egészségügyi jellegű, különleges
          kategóriájú személyes adatnak</strong> minősülhetnek. Jogalap: GDPR 9. cikk (2) a) — a Felhasználó <strong>kifejezett
          hozzájárulása</strong>, amelyet az adatok önkéntes rögzítésével ad meg, valamint GDPR 6. cikk (1) b) — a coaching
          szolgáltatási szerződés teljesítése. A bejegyzést a Felhasználó saját maga, vagy — személyes (offline) edzés esetén,
          a Felhasználó tudtával — az edző rögzíti; minden bejegyzésen tároljuk, hogy ki vitte fel. Az adatok kizárólag a
          Felhasználó és az edző számára láthatók, harmadik félnek nem kerülnek átadásra.
        </li>
        <li>
          <strong>Étrend (mintaétrend) — egészségügyi jellegű adatok:</strong> A Kliens Portálon elérhető étrend
          funkció keretében kezelt adatok: a Felhasználó részére generált <strong>általános mintaétrend</strong> (napok,
          étkezések, hozzávalók, mennyiségek), a hozzá tartozó kalória- és makrótápanyag-célok (kcal, fehérje, szénhidrát,
          zsír), valamint a Felhasználó által beállított étrendi preferenciák (pl. vegetáriánus, vegán, laktózmentes,
          konyhaválasztás). Az étrend nem minősül dietetikai tanácsadásnak vagy terápiás étrendnek, azonban az étrendi
          preferenciák és a mintaétrend <strong>egészségügyi jellegű, különleges kategóriájú személyes adatnak</strong>
          minősülhetnek. Jogalap: GDPR 9. cikk (2) a) — a Felhasználó <strong>kifejezett hozzájárulása</strong>, amelyet a
          kalkulátor kitöltésével és a coaching szolgáltatás megrendelésével ad meg, valamint GDPR 6. cikk (1) b) — a
          coaching szolgáltatási szerződés teljesítése. Az étrendet és a preferenciákat az edző rögzíti, majd a Felhasználó
          fiókjában olvasható. Az adatok kizárólag a Felhasználó és az edző számára láthatók, harmadik félnek nem kerülnek
          átadásra.
        </li>
        <li>
          <strong>Tudástár cikk-sorozat e-mailek:</strong> A hírlevél-sorozat (Drip kampány) lezárulta után a Felhasználó
          hetente legfeljebb egy e-mailt kap a Tudástár újonnan megjelent szakmai cikkeivel. Jogalap: a hírlevélre adott
          hozzájárulás (GDPR 6. cikk (1) a)). A sorozatról bármikor le lehet iratkozni a levelek alján található linkkel.
        </li>
        <li>
          <strong>E-mail megnyitási és kattintási statisztika:</strong> A kiküldött rendszer- és hírlevél-e-mailekhez
          kapcsolódóan a levelezőszolgáltató (Resend Inc.) technikai visszajelzést adhat arról, hogy az e-mail megnyitásra
          vagy a benne lévő link kattintásra került-e. Ezt kizárólag a hírlevél-szolgáltatás minőségének mérésére, összesített
          statisztika formájában használjuk. Jogalap: GDPR 6. cikk (1) f) — jogos érdek. A mérés a leiratkozással együtt
          automatikusan megszűnik.
        </li>
      </ul>
    </section>

    <section>
      <h2 className="text-xl font-bold text-gray-900 mb-3" style={{ fontFamily: 'Montserrat, sans-serif' }}>
        3. Az adatkezelés időtartama
      </h2>
      <ul className="list-disc pl-6 space-y-2">
        <li>
          <strong>Hírlevél, edukációs kampány, kalkulátor-eredmények:</strong> a Felhasználó
          <strong> hozzájárulásának visszavonásáig</strong> (leiratkozásig). A levelek alján található leiratkozási linkre
          kattintva bármikor, azonnal és ingyenesen kérhető az adatok törlése.
        </li>
        <li>
          <strong>Kliens Portál fiók (bérletek, foglalások):</strong> a fiók fennállásáig, illetve a Felhasználó fiók-törlési
          kérelméig. Törlést az <a href="mailto:info@oroszcoaching.hu" className="text-yellow-700 hover:text-yellow-600 font-semibold">info@oroszcoaching.hu</a> e-mail címen lehet kezdeményezni.
          A törlést az Adatkezelő 30 napon belül elvégzi, kivéve azon adatokat, amelyekre a következő pont vonatkozik.
        </li>
        <li>
          <strong>Edzésterv, edzésnapló és testméret-adatok:</strong> a fiók fennállásáig, illetve a Felhasználó törlési
          kérelméig. A fiók törlésével ezek az adatok — beleértve az edzésterv korábbi verzióit is — véglegesen és
          visszaállíthatatlanul törlésre kerülnek.
        </li>
        <li>
          <strong>Számviteli bizonylatokhoz kapcsolódó adatok</strong> (számlázási név, cím, adószám, tranzakció összege,
          dátuma): a hatályos <strong>2000. évi C. törvény (Sztv.) 169. § (2) bekezdése</strong> alapján a kiállítást követő
          <strong> 8 évig</strong> megőrizzük.
        </li>
        <li>
          <strong>Anonimizált analitikai adatok (Google Analytics 4):</strong> alapértelmezetten legfeljebb 14 hónapig,
          azonosításra alkalmatlan formában.
        </li>
      </ul>
    </section>

    <section>
      <h2 className="text-xl font-bold text-gray-900 mb-3" style={{ fontFamily: 'Montserrat, sans-serif' }}>
        4. Adattovábbítási Nyilatkozat (Barion fizetéshez kötelező passzus)
      </h2>
      <div className="bg-yellow-50 border-l-4 border-yellow-600 p-4 rounded-r-lg">
        <p>
          A Felhasználó tudomásul veszi, hogy a(z) <strong>Orosz Gábor</strong> adatkezelő által az{' '}
          <a href="https://oroszcoaching.hu" className="text-yellow-700 hover:text-yellow-600 font-semibold">oroszcoaching.hu</a>{' '}
          felhasználói adatbázisában tárolt személyes adatai átadásra kerülnek a{' '}
          <strong>Barion Payment Zrt.</strong>, mint adatfeldolgozó felé.
        </p>
        <p className="mt-2">
          <strong>A továbbított adatok köre:</strong> felhasználónév, vezetéknév, keresztnév, ország,
          telefonszám, e-mail cím, számlázási cím adatai.
        </p>
        <p className="mt-2">
          <strong>Az adattovábbítás célja:</strong> a felhasználók részére történő bankkártyás fizetési
          szolgáltatás biztosítása, a tranzakciók biztonsági ellenőrzése (Barion Smart Gateway és Barion Pixel használata).
        </p>
      </div>
    </section>

    <section>
      <h2 className="text-xl font-bold text-gray-900 mb-3" style={{ fontFamily: 'Montserrat, sans-serif' }}>
        5. Adatfeldolgozók köre
      </h2>
      <p>
        Az adatok biztonságos tárolása és a szolgáltatás működtetése érdekében az alábbi külső szolgáltatók
        (adatfeldolgozók) rendszereit használjuk, amelyek maximálisan megfelelnek a nemzetközi GDPR szabályoknak:
      </p>
      <ol className="list-decimal pl-6 space-y-2 mt-3">
        <li><strong>Tárhelyszolgáltató:</strong> Rackhost Zrt. (6722 Szeged, Tisza Lajos körút 41., info@rackhost.hu) — a domain és az alapvető DNS beállítások kezelésére.</li>
        <li><strong>Felhőtárhely és Adatbázis:</strong> Emergent Cloud Infrastructure &amp; Native MongoDB — a weboldal futtatására és a feliratkozók technikai tárolására.</li>
        <li><strong>Levelezőrendszer:</strong> Resend Inc. (resend.com) — az automatizált rendszerüzenetek és hírlevelek kiküldésére.</li>
        <li><strong>Adminisztráció:</strong> Google LLC (Google Drive API) — a konzultációt foglalt ügyfelek egyedi adatlapjainak és mappáinak automatikus létrehozására és tárolására.</li>
        <li>
          <strong>Ügyfélfiókos bejelentkezés (opcionális):</strong> Google LLC (Google Sign-In / Emergent-managed Google OAuth) —
          amennyiben a Felhasználó a „Bejelentkezés Google-fiókkal” gombot választja, a Google felé a bejelentkezési kérésen
          túl csak a Felhasználó által jóváhagyott alapadatok (név, e-mail cím, profilkép URL) kerülnek átadásra, kizárólag
          a Kliens Portál autentikációjához. Az Adatkezelő a Google-jelszót <em>nem látja és nem tárolja</em>. Adattovábbítás
          harmadik országba (USA) történik, amelynél a Google <em>EU-U.S. Data Privacy Framework</em> (2023) tanúsítása
          biztosítja a GDPR-nak megfelelő adatvédelmi szintet.
        </li>
        <li><strong>Számlázási rendszer:</strong> KBOSS.hu Kft. (Számlázz.hu) — az elektronikus számlák automatikus kiállítására.</li>
        <li><strong>Online fizetési partner:</strong> Barion Payment Zrt. — a bankkártyás tranzakciók lebonyolítására.</li>
        <li>
          <strong>Weboldal-analitika:</strong> Google LLC (Google Analytics 4) — anonimizált IP-címmel gyűjtött látogatottsági
          és felhasználói viselkedési adatok elemzésére. Adattovábbítás harmadik országba (USA) történik, amelynél a Google
          <em> EU-U.S. Data Privacy Framework</em> (2023) tanúsításai és a Google által aláírt <em>Standard Contractual
          Clauses</em> (SCC) biztosítják a GDPR-nak megfelelő adatvédelmi szintet.
        </li>
        <li>
          <strong>Marketing / hirdetéskövetés (Meta Pixel):</strong> Meta Platforms Ireland Limited (Facebook / Instagram) —
          hirdetési kampányok eredményének mérésére (konverziók: érdeklődés, kapcsolatfelvétel, foglalás, vásárlás),
          célzott hirdetésekhez és „hasonmás közönségek" (Lookalike Audience) létrehozásához. Adatkör: IP-cím, cookie
          azonosító (_fbp), user agent, oldalletöltési események. Az adatok kizárólag azon Felhasználók esetében kerülnek
          továbbításra a Meta felé, akik a Cookie Consent bannerben a marketing sütiket elfogadták (kifejezett hozzájárulás —
          GDPR 6. cikk (1) a)). Adattovábbítás harmadik országba (USA) történik, amelynél a Meta <em>EU-U.S. Data Privacy
          Framework</em> (2023) tanúsítása és <em>Standard Contractual Clauses</em> (SCC) biztosítják a GDPR-nak megfelelő
          adatvédelmi szintet. A hozzájárulás bármikor visszavonható a Cookie Consent banner újranyitásával vagy a böngésző
          süti-beállításain keresztül.
        </li>
      </ol>
    </section>

    <section>
      <h2 className="text-xl font-bold text-gray-900 mb-3" style={{ fontFamily: 'Montserrat, sans-serif' }}>
        6. Sütik (Cookies) használata
      </h2>
      <p>
        A weboldal működéséhez, valamint a látogatottság méréséhez sütiket (cookie-kat) használunk. A sütik két
        kategóriába sorolhatók:
      </p>
      <ul className="list-disc pl-6 space-y-2 mt-3">
        <li>
          <strong>Elengedhetetlen (session) sütik:</strong> a bejelentkezés, a kosár és a fizetési folyamat működéséhez
          szükségesek. Ezek használatához nem szükséges külön hozzájárulás (jogalap: GDPR 6. cikk (1) f) — jogos érdek).
        </li>
        <li>
          <strong>Analitikai sütik (Google Analytics 4):</strong> a látogatottság mérésére és a felhasználói élmény
          javítására szolgálnak. A tárolt sütik (<code>_ga</code>, <code>_ga_&lt;property_id&gt;</code>) anonimizált
          formában tartalmazzák a látogatói azonosítót. A <em>Google Consent Mode v2</em> alapján ezek a sütik alapértelmezésben
          <strong> kikapcsolva</strong> maradnak, és csak a Felhasználó <strong>kifejezett hozzájárulása</strong> után aktiválódnak
          (jogalap: GDPR 6. cikk (1) a) — hozzájárulás).
        </li>
      </ul>
      <p className="mt-3">
        <strong>A hozzájárulás megadása és visszavonása:</strong> A weboldal első meglátogatásakor süti-tájékoztató banner
        jelenik meg. A hozzájárulást a Felhasználó <strong>bármikor visszavonhatja</strong> az alábbi gombra kattintva:
      </p>
      <div className="mt-3">
        <button
          type="button"
          data-testid="cookie-reopen-button"
          onClick={() => typeof window !== 'undefined' && typeof window.reopenCookieConsent === 'function' && window.reopenCookieConsent()}
          className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-yellow-600 hover:bg-yellow-700 text-white font-semibold text-sm transition-colors"
        >
          Cookie-beállítások módosítása
        </button>
      </div>
    </section>

    <section>
      <h2 className="text-xl font-bold text-gray-900 mb-3" style={{ fontFamily: 'Montserrat, sans-serif' }}>
        7. Kliens Portál fiók, automatizált üzenetek és fiók törlése
      </h2>
      <p>
        A Kliens Portál (<a href="/fiokom" className="text-yellow-700 hover:text-yellow-600 font-semibold">/fiokom</a>) egy
        opcionális, ingyenesen létrehozható ügyfélfiók, amely a bérletek nyilvántartását, edzés-időpontok foglalását és
        a személyre szabott értesítéseket teszi lehetővé.
      </p>
      <ul className="list-disc pl-6 space-y-2 mt-3">
        <li>
          <strong>Bejelentkezés:</strong> a Felhasználó választhat e-mail + jelszó vagy Google-fiókos bejelentkezés között.
          A jelszavakat a rendszer <strong>bcrypt</strong> algoritmussal, visszafejthetetlen formában tárolja; az Adatkezelő
          a jelszót nem ismeri.
        </li>
        <li>
          <strong>Fiókban tárolt adatok:</strong> név, e-mail cím, opcionális telefonszám, a bejelentkezés módja
          (jelszavas / Google), regisztráció dátuma, valamint a Felhasználóhoz tartozó bérletek, foglalások és kuponok
          nyilvántartása.
        </li>
        <li>
          <strong>Automatizált tranzakciós e-mailek</strong> (jogalap: szerződés teljesítése — GDPR 6. cikk (1) b)):
          fizetés visszaigazolása, bérlet aktiválása, foglalás visszaigazolása, foglalás lemondás. Ezek a szolgáltatás
          működéséhez elengedhetetlenek, így külön leiratkozási lehetőség nélkül kerülnek kiküldésre.
        </li>
        <li>
          <strong>Automatizált retenciós e-mailek</strong> („alacsony egyenleg”, „hamarosan lejáró bérlet”) és a hozzájuk
          tartozó, egyszer felhasználható 10%-os hűségkupon (jogalap: jogos érdek — GDPR 6. cikk (1) f)). A Felhasználó
          ezekről az üzenetekről bármikor leiratkozhat az <a href="mailto:info@oroszcoaching.hu" className="text-yellow-700 hover:text-yellow-600 font-semibold">info@oroszcoaching.hu</a> címre küldött e-mailben.
        </li>
        <li>
          <strong>Fiók törlése:</strong> a Felhasználó bármikor kérheti a Kliens Portál fiókjának teljes törlését az
          <a href="mailto:info@oroszcoaching.hu" className="text-yellow-700 hover:text-yellow-600 font-semibold"> info@oroszcoaching.hu</a> címen. A kérelmet az Adatkezelő 30 napon belül teljesíti. A már kiállított számlákhoz
          kapcsolódó, jogszabály által kötelezően megőrzendő adatok (Sztv. 8 év) törlésére nincs mód; ezek anonimizálva /
          zároltan maradnak a rendszerben.
        </li>
      </ul>
    </section>

    <section>
      <h2 className="text-xl font-bold text-gray-900 mb-3" style={{ fontFamily: 'Montserrat, sans-serif' }}>
        8. Az Érintettek jogai
      </h2>
      <p>
        A Felhasználó bármikor jogosult <strong>tájékoztatást kérni</strong> a róla kezelt adatokról, kérheti azok{' '}
        <strong>helyesbítését, korlátozását vagy azonnali törlését</strong> az{' '}
        <a href="mailto:info@oroszcoaching.hu" className="text-yellow-700 hover:text-yellow-600 font-semibold">info@oroszcoaching.hu</a>{' '}
        e-mail címen.
      </p>
      <p className="mt-3">
        Jogorvoslati lehetőséggel a <strong>Nemzeti Adatvédelmi és Információszabadság Hatósághoz</strong> (NAIH) lehet fordulni:
      </p>
      <ul className="list-disc pl-6 space-y-1 mt-2 text-sm">
        <li>Cím: 1055 Budapest, Falk Miksa utca 9-11.</li>
        <li>Postacím: 1363 Budapest, Pf.: 9.</li>
        <li>E-mail: <a href="mailto:ugyfelszolgalat@naih.hu" className="text-yellow-700 hover:text-yellow-600 font-semibold">ugyfelszolgalat@naih.hu</a></li>
        <li>Web: <a href="https://www.naih.hu" target="_blank" rel="noopener noreferrer" className="text-yellow-700 hover:text-yellow-600 font-semibold">www.naih.hu</a></li>
      </ul>
    </section>
  </LegalPageLayout>
);

export default AdatvedelemPage;
